/**
 * React Router loaders build `request.url` without the fragment.
 * Fall back to `window.location.hash` so deep links survive client redirects.
 */
export function getRequestHash(request: Request): string {
  const fromRequest = new URL(request.url).hash;
  if (fromRequest) return fromRequest;
  if (typeof window !== 'undefined') return window.location.hash;
  return '';
}
